<template>
  <div>
    <v-card class="pa-3">
      <div class="text-xs-right">
        <v-btn icon ripple flat @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <div class="py-2">
        <div class="mt-2">
          <div class="caption">Ticket ID:</div>
          <div class="form-control">
            <input v-model="input.ticket_id" type="text" :placeholder="'Ticket ID'" />
          </div>
        </div>
        <div class="mt-2">
          <div class="caption">Ticket Name:</div>
          <div class="form-control">
            <input v-model="input.ticket_name" type="text" :placeholder="'Ticket Name'" />
          </div>
        </div>
        <div class="mt-2">
          <div class="caption">Group:</div>
          <div class="form-control mb-2">
            <multiselect
              v-model="input.group"
              :options="agentGroupOptions"
              label="groupname"
              :placeholder="'Group'"
              :max-height="250"
            >
            </multiselect>
          </div>
        </div>
        <div class="mt-2">
          <div class="caption">SubGroup:</div>
          <div class="form-control mb-2">
            <multiselect
              v-model="input.subgroup"
              :options="agentSubGroupOptions"
              label="subgroupname"
              :placeholder="'SubGroup'"
              :max-height="250"
            >
            </multiselect>
          </div>
        </div>
        <div class="mt-2">
          <div class="caption">Agent:</div>
          <div class="form-control">
            <multiselect
              v-model="input.agent_name"
              :options="agentOptions"
              label="adminid"
              :placeholder="'Agent'"
              :max-height="250"
              :open-direction="'above'"
            >
            </multiselect>
          </div>
        </div>
        <div class="mt-2">
          <div class="caption">{{ $t('phone no.') }}</div>
          <div class="form-control">
            <input v-model="input.phone_number" type="text" :placeholder="$t('phone no.')" />
          </div>
        </div>
        <div class="mt-2">
          <div class="caption">{{ $t('Tags') }}</div>
          <multiselect
            v-model="input.tags"
            :options="tagOptions"
            :placeholder="$t('Tags')"
            :multiple="true"
            :taggable="true"
            @tag="addTag"
          >
          </multiselect>
        </div>
        <div class="mt-2">
          <v-layout>
            <v-flex class="pa-1">
              <v-btn block depressed @click="clearSearch">
                <v-icon>clear</v-icon>
                {{ $t('Clear All') }}
              </v-btn>
            </v-flex>
            <v-flex class="pa-1">
              <v-btn block depressed color="primary" @click="onSearch">
                <v-icon>search</v-icon>
                {{ $t('Search') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import api from '@/api'

export default {
  components: {
    Multiselect
  },
  data() {
    return {
      input: {
        ticket_id: '',
        ticket_name: '',
        group: '',
        subgroup: '',
        agent_name: '',
        phone_number: '',
        email: '',
        tags: ''
      },
      tagOptions: [],
      groupOptions: [],
      subgroupOptions: []
    }
  },
  computed: {
    ...mapGetters({
      agentGroup: 'getAgentGroup',
      agentSubGroup: 'getAgentSubgroup',
      agent: 'getAgent',
      selectedBot: 'selectedBot',
      loadingAgentGroup: 'getLoadingAgentGroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup',
      loadingAgent: 'getLoadingAgent'
    }),
    agentGroupOptions() {
      if (this.agentGroup && this.agentGroup.length) {
        return this.agentGroup
      } else {
        return []
      }
    },
    agentSubGroupOptions() {
      if (this.agentSubGroup && this.agentSubGroup.length) {
        return this.agentSubGroup
        // return this.agentSubGroup.filter((el) => {
        //   return el.admingroupid == this.transfer.group.id
        // })
      } else {
        return []
      }
    },
    agentOptions() {
      if (this.agent && this.agent.length) {
        return this.agent
      } else {
        return []
      }
    }
  },
  mounted() {
    this.getUserTagList()
  },

  methods: {
    async getUserTagList() {
      var response = await api.getUserTagList()
      if (response && response.result) {
        response.result.map((item) => {
          this.tagOptions.push(item.name)
        })
      }
    },
    addTag(newTag) {
      const tag = newTag
      this.tagOptions.push(tag)
      this.input.tags.push(tag)
    },
    onSearch() {
      this.$emit('onSearch', this.input)
      console.log('input: ', this.input)
    },
    clearSearch() {
      this.input = {
        ticket_id: '',
        ticket_name: '',
        group: '',
        subgroup: '',
        agent_name: '',
        phone_number: '',
        email: '',
        tag: ''
      }

      this.$emit('onSearch', this.input)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/AdvancedSearch.vue